import { Documento } from "@app/shared/helpers/interfaces/documento";
import { RespApi } from "@app/shared/helpers/interfaces/resp-api";

export const RESPUESTA_REQUISITOS: RespApi = {
    "codigoError": 200,
    "error": false,
    "mensaje": "Operación correcta",
    "version": "0.0",
    "total": 1,
    "data": {
        "id": "19",
        "contenido": "<p>DATOS ESTATICOS</p>",
        "idUsuario": null,
        "fecha": "2022-01-28 15:29:26"
    }
}


export const RESPUESTA_CONCEPTOS: RespApi = {
    "codigoError": 200,
    "error": false,
    "mensaje": "Operación correcta",
    "version": "0.0",
    "total": 1,
    "data": {
        "conceptos": [
            {
                "idObjeto": "1",
                "texto": "Desarrollo del proyecto a partir de especificaciones indicadas en este documento",
                "posicion": "1",
                "importe": "0.00"
            }
        ],
        "importeTotal": "0.00"
    }
}


export const RESPUESTA_ANALISISFUNCIONAL = {
    "codigoError": 200,
    "error": false,
    "mensaje": "Operación correcta",
    "version": "0.0",
    "total": 1,
    "data": {
        "queHaremosDescripcionGeneral": {
            "id": "27",
            "contenido": "<h2>What is Lorem Ipsum?</h2><p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><h2>Why do we use it?</h2><p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>",
            "idUsuario": null,
            "fecha": "2022-02-10 14:48:26"
        },
        "queHaremosDescripcionTecnica": {
            "id": "28",
            "contenido": "<h2>What is Lorem Ipsum?</h2><p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><h2>Why do we use it?</h2><p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>",
            "idUsuario": null,
            "fecha": "2022-02-10 14:48:26"
        },
        "queNecesitamos": {
            "id": "29",
            "contenido": "<h2>What is Lorem Ipsum?</h2><p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><h2>Why do we use it?</h2><p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>",
            "idUsuario": null,
            "fecha": "2022-02-10 14:48:26"
        }
    }
};


export const RESPUESTA_ANALISISFUNCIONAL_ERROR = 
{
    "codigoError": 422,
    "error": true,
    "mensaje": "Parámetros no válidos",
    "version": "0.0",
    "total": 1,
    "data": [
        {
            "id": "queHaremosDescripcionGeneral",
            "mensaje": "El campo Descripción general es obligatorio."
        }
    ]
}


export const RESPUESTA_ESTIMACION_PROYECTO = {
    "codigoError": 200,
    "error": false,
    "mensaje": "Operación correcta",
    "version": "0.0",
    "total": 1,
    "data": {
        "id": "2",
        "identificador": "EST000002",
        "idObjeto": "2",
        "tiempoTotalMinimo": "342",
        "tiempoTotalMaximo": "294",
        "precioEstimadoMinimo": "23710",
        "precioEstimadoMaximo": "14140",
        "activa": "1",
        "estimacionesDepartamento": {
            "ADM": {
                "horasMin": "10",
                "horasMax": "165",
                "precioHora": "36",
                "nombreDepartamento": "Administración",
                "identificadorDepartamento": "ADM"
            },
            "SW-ADR": {
                "horasMin": "10",
                "horasMax": "15",
                "precioHora": "75",
                "nombreDepartamento": "App Android Software",
                "identificadorDepartamento": "SW-ADR"
            },
            "SW-IOS": {
                "horasMin": "10",
                "horasMax": "11",
                "precioHora": "75",
                "nombreDepartamento": "App iOS Software",
                "identificadorDepartamento": "SW-IOS"
            },
            "SW-BACK": {
                "horasMin": "25",
                "horasMax": "22",
                "precioHora": "75",
                "nombreDepartamento": "Backend Software",
                "identificadorDepartamento": "SW-BACK"
            },
            "SW-DIR": {
                "horasMin": "225",
                "horasMax": "22",
                "precioHora": "75",
                "nombreDepartamento": "Dirección Software",
                "identificadorDepartamento": "SW-DIR"
            },
            "DIS": {
                "horasMin": "25",
                "horasMax": "22",
                "precioHora": "50",
                "nombreDepartamento": "Diseño",
                "identificadorDepartamento": "DIS"
            },           
            "SW-FRNT": {
                "horasMin": "25",
                "horasMax": "25",
                "precioHora": "50",
                "nombreDepartamento": "Frontend Software",
                "identificadorDepartamento": "SW-FRNT"
            },
            "SW-MAQU": {
                "horasMin": "12",
                "horasMax": "12",
                "precioHora": "50",
                "nombreDepartamento": "Maquetación Software",
                "identificadorDepartamento": "SW-MAQU"
            },
           
            
        }
    }
}

export const RESPUESTA_ESTIMACION_PROYECTO__ERROR_NOEDITABLE = {
    "codigoError": 403,
    "error": true,
    "mensaje": "Operación no autorizada",
    "version": "0.0",
    "total": 1,
    "data": [
        {
            "id": 999,
            "mensaje": "La propuesta debe estar en estado PENDIENTE DE ESTIMACION para poder guardar la estimación"
        }
    ]
}


export const RESPUESTA_ESTIMACION_PROYECTO_ERROR = 
{
    "codigoError": 422,
    "error": true,
    "mensaje": "Parámetros no válidos",
    "version": "0.0",
    "total": 0,
    "data": []
}

export const FICHEROS_PROYECTO: Documento[] = [
    {
        "id": "10",
        "idObjeto": '1',
        "idUsuario": "14",
        "nombreModeloObjeto": 'propuesta',
        "nombre": "accionesmultiplemovil.png",
        "ruta": "data/propuesta/1/fichero/10/accionesmultiplemovil.png",
        "fecha": new Date ('2022-01-28 15:29:26')
    }
]


